<template>
  <div class="Charts">
    <v-container fluid class="ma-0">
  <template>
  <v-row>
  <v-col>
  <v-card
    class="mt-4 mx-auto"
    max-width="100%"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
    <apexchart
      ref="pieChart"
      type="treemap"
      height="670"
      :options="treemapOptions"
      :series="distSeries"></apexchart>

    </v-sheet>
    <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Αγορές/Πωλήσεις ανταλλακτικών
      </div>
      <div class="subheading font-weight-light grey--text">
        Σύνολο αγορών ανα προμηθευτή για το διάστημα {{range}}.
        <p>(Σύνολική αξία αγοράς ανταλλακτικών {{ tocurr(dincome) }}</p>
        <p>(Σύνολική αξία πώλησης ανταλλακτικών {{ tocurr(aincome)}}</p>
        <p>(Σύνολική αξία υπηρεσιών {{ tocurr(sincome)}}</p>
        <p>(Σύνολική αξία ανταλλακτικών {{tocurr(sincome*0.40+aincome*0.40)}} ({{kerdosa}}-{{kerdose}})</p>
        
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-clock
      </v-icon>
      <span class="text-caption grey--text font-weight-light">last registration 26 minutes ago</span>
  <v-select
    :items="['full', 'week', 'month', '3month', '6month', 'year']"
    v-model="range"
    label="Χρονική περίοδος"
    @change="updateChart"
    >
  </v-select>
    </v-card-text>
  </v-card>
  </v-col>
  </v-row>
</template>
    </v-container>
  </div>
</template>

<script>
import { reverse as _reverse, sortBy as _sortBy } from 'lodash';
import VueApexCharts from 'vue-apexcharts'


export default {
  computed: {
    //pist () { return this.tocurr(this.sumField(this.invoices.filter(e => (e.PaymTerm == "Με πίστωση" && e.state == "Κανονικό") ), 'TotalValue')); },
    //metr () { return this.tocurr(this.sumField(this.invoices.filter(e => (e.PaymTerm == "Μετρητοίς"&& e.state == "Κανονικό")), 'TotalValue')); },
    //total () { return this.tocurr(this.sumField(this.invoices.filter(e => e.state == "Κανονικό"), 'TotalValue')); },
    kerdosa () { return this.tocurr( this.sincome*0.40) },
    kerdose () { return this.tocurr( this.aincome*0.40) }

  },
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      // chart
      dincome: 0.0,
      sincome: 0.0,
      aincome: 0.0,
      range: "week",
      histSel: "purchases",
      distSeries: [
        {name: "asdsa" , data : []},
        {name: "sales" , data : []},
        {name: "sales" , data : []},
      ],
      treemapOptions: {
        chart: {
          type: "treemap",
        },

        tooltip: {
          enabled: true,
          y: {
            formatter: this.tocurr,
          },
        },
       dataLabels: {
            enabled: true,
            style: {
              fontSize: '16px',
            },
         formatter: this.currencyFmtTree,
            offsetY: -4
          },
        plotOptions: {
          treemap: {
            //enableShades: true,
            //distributed: true,
          }
        },
      },
      // data
      loading: true,
      hist: [{}, {}, {}],

    };
  },
  async created() {
    await this.updateChart();
  },
  watch: {
    timdialog(val) {
      val || this.close();
    },
  },
  methods: {
    currencyFmtTree(text, op) {
      let pcnt =  ((op.value / this.dincome)*100).toFixed(2);
      return [text.split('||').pop(), this.tocurr(op.value) +  " ("  +pcnt + "%)" ];
    },
    async updateChart () {
      // let arr = this.sumDist();
      // this.distSeries = arr.series;
      // this.pieOptions = {labels: arr.labels};
      await this.fetchdata();
      this.distSeries = [
      { name: "purchases", data: this.sumDistTree(this.hist[0])},
      { name: "sales", data: this.sumDistTree(this.hist[1])},
      { name: "sales", data: this.sumDistTree(this.hist[2])}
      ];
    },
    sumDistTree(hist) {
      let series = [];
      for (let k in hist) {
        //series.push({x: k, y: this.hist[k]});
        series.push({x: hist[k].name, y: hist[k].total});
      }
      return _reverse(_sortBy(series, 'y'));
    },
    close() {
      this.timdialog = false;
    },
    async fetchdata() {
      try {
        let response = await this.$api.get("/suppliers/purchases_hist", {
          params: {
            range: this.range,
          },
        });
        //console.log(response);
        this.hist[0] = response.data;
        response = await this.$api.get("/aade/sales_hist", {
          params: {
            range: this.range,
          },
        });
        this.hist[1] = response.data[0];
        this.hist[2] = response.data[1];
        this.dincome = this.summer(this.hist[0]);
        this.aincome = this.summer(this.hist[1]);
        this.sincome = this.summer(this.hist[2]);
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    summer(obj) {
      let s = 0;
      for (let k in obj) {
        s += obj[k].total;
      }
      return s;
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  },
};
</script>
